import eventType from '../../shares/enums/eventType';
import eventEmitters from '../../shares/lib/eventEmitters';
import { getSDKConfig } from '../../shares/lib/getSDKConfig';
import logger from '../../shares/lib/logger';
import fetchMiniGameData from './fetchMiniGameData';
import { renderGameUI } from './renderGameUI';
import { renderMiniGameRootUI } from './renderMiniGameRootUI';
import renderPlaceHolderUI from './renderPlaceHolderUI';
import { validateMiniGameConfig } from './validateMiniGameConfig';

const miniGamesService = async () => {
  const swipeSDKConfig = getSDKConfig();

  if (!validateMiniGameConfig()) {
    return;
  }

  const { domElement } = swipeSDKConfig.miniGames || {};

  const selectedContainer = document.querySelector(`${domElement}`);

  if (!selectedContainer) {
    logger.error('Selected container not found.');
    return;
  }

  const finalResponse = await fetchMiniGameData(swipeSDKConfig);

  const { gameData } = finalResponse;

  selectedContainer.innerHTML = renderMiniGameRootUI();
  eventEmitters(eventType.MINI_GAMES_READY);
  if (swipeSDKConfig.miniGames?.launchOnLoad && gameData) {
    renderGameUI(finalResponse);
    return;
  }

  renderPlaceHolderUI(finalResponse);
};

export default miniGamesService;
